import React from 'react';

import { Box } from '@mui/material';
import { Tooltip, useAlert, useAlertsContext } from '@uplift/ui-v2';


export type DisabledActionAlertProps = {
  message: React.ReactNode;
  tooltip: string;
};


export const DisabledActionAlert: React.FC<DisabledActionAlertProps> = ({ message, tooltip, children }) => {
  const alert = useAlert();
  const { alerts } = useAlertsContext();

  const showReason = React.useCallback(() => {
    if (alerts.some(shown => shown.message === message)) {
      return;
    }

    alert.info(message, { preventDuplicate: true });
  }, [ alert, alerts, message ]);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    showReason();
  };

  return (
    <Tooltip title={tooltip}>
      <Box
        component="span"
        role="button"
        tabIndex={0}
        display="inline-flex"
        sx={{ cursor: 'pointer', borderRadius: 1 }}
        onClick={showReason}
        onKeyDown={handleKeyDown}
      >
        {children}
      </Box>
    </Tooltip>
  );
};
